module.exports = __webpack_public_path__ + "b9c04a3c16c8e833a13b028e34b6d5af.svg";